import { isSalesViewEnabled } from '@ab-core-functions/sales-view';
import { userHasOnlySalesView as userHasOnlySalesViewFunction } from '@ab-core-functions/user-permission';
import { formatNumber, formatPrice } from '@ab-core/functions';
import type { PositionPriceObject, Scaleprice } from '@ab-core/graphql/dist/index';
import { useAuth } from '@ab-core/hooks';
import { getTestIdProp } from '@ab-core/testing';
import Text from '@ab-core/text';
import type { FC } from 'react';
import React from 'react';
import { AddScaleQuantityToCartButton } from './components/addScaleQuantityToCartButton';

type ScalePricesType = {
    quantity: number;
    quantityUnit: string;
    salesUnit: number;
    cartId?: string;
    sku: string;
} & Pick<PositionPriceObject, 'priceObject'>;

export const ScalePrices: FC<ScalePricesType> = (props) => {
    const { quantityUnit, priceObject, salesUnit, cartId, sku } = props;
    const { user } = useAuth();
    const isSalesView = isSalesViewEnabled(user?.activeAccount?.accountNumber);
    const userHasOnlySalesView = userHasOnlySalesViewFunction();

    const scalePrices: Scaleprice[] | null | undefined =
        priceObject?.value?.centAmount && priceObject?.scalePrices
            ? [
                  {
                      quantity: salesUnit,
                      value: {
                          currencyCode: 'EUR',
                          fractionDigits: 2,
                          centAmount: priceObject.value.centAmount
                      }
                  } as Scaleprice,
                  ...priceObject.scalePrices
              ]
            : undefined;

    return (
        <>
            {scalePrices?.map(
                (scalePrice, index) =>
                    !isSalesView &&
                    !userHasOnlySalesView && (
                        <div
                            key={index}
                            className="flex-justify-content-space-between"
                            {...getTestIdProp('product-detail-page-scale-prices')}
                        >
                            <Text className="ml-small-2">
                                {index === 0 ? 'Preis pro' : ' - ab'}{' '}
                                {index === 0
                                    ? formatNumber(priceObject?.priceReference)
                                    : formatNumber(scalePrice.quantity)}{' '}
                                {quantityUnit}
                            </Text>
                            {index === 0 ? (
                                <Text>{scalePrice.value && formatPrice(scalePrice.value)}</Text>
                            ) : (
                                <AddScaleQuantityToCartButton scalePrice={scalePrice} sku={sku} cartId={cartId} />
                            )}
                        </div>
                    )
            )}
        </>
    );
};
